<div class="portal-page">

	<!-- Top bar -->
	<portal-header mode="section" [projectId]="projectId" current="quotes" [sections]="sections"></portal-header>

	<portal-loader *ngIf="loading"></portal-loader>
	<div class="sec-state portal-error" *ngIf="error">{{ error }}</div>

	<ng-container *ngIf="!loading && !error">

		<!-- Summary: accepted value + payment summary + payment details -->
		<portal-project-totals [projectId]="projectId"></portal-project-totals>

		<!-- Filter tabs -->
		<div class="sec-filter-tabs">
			<button class="portal-pill" *ngFor="let tab of tabs" [class.active]="filter === tab.key" (click)="filter = tab.key">
				{{ tab.label }} <span class="portal-pill-count">{{ counts[tab.key] || 0 }}</span>
			</button>
			<label class="sec-search-pill">
				<i class="wq wq-search"></i>
				<input type="text" placeholder="Search" [(ngModel)]="search">
			</label>
		</div>

		<!-- Quote rows -->
		<div class="sec-list">
			<p class="sec-state" *ngIf="!filtered.length">No quotes to show.</p>

			<div class="qr" *ngFor="let q of filtered">
				<div class="qr-thumb">
					<img class="qr-thumb-img" [src]="q.image_url || 'assets/image-placeholder.png'" alt="">
				</div>

				<div class="qr-name">
					<div class="qr-meta">
						<span class="qr-number">Quote #{{ q.quote_no }}</span>
						<span class="qr-revision" *ngIf="q.revision > 1 || q.revision_name">Revision <ng-container *ngIf="q.revision_name">{{ q.revision_name }} </ng-container>{{ q.revision }}</span>
					</div>
					<div class="qr-title">{{ q.title }}</div>
				</div>

				<div class="qr-status">
					<span class="badge" [ngClass]="badgeClass(q.status)">{{ badgeLabel(q.status) }}</span>
					<span class="qr-date" [ngClass]="dateLabel(q).cls">{{ dateLabel(q).text }}</span>
				</div>

				<div class="qr-payment">
					<ng-container *ngIf="q.status === 'accepted' && q.payment">
						<div class="qr-payment-label">Payment Summary</div>
						<div class="qr-payment-amount-row">
							<span class="qr-payment-big">{{ q.payment.paid | currency:q.currency_id }}</span>
							<span class="qr-payment-of">of {{ q.payment.total | currency:q.currency_id }} Paid so far</span>
						</div>
						<portal-progress-bar size="sm" [paid]="q.payment.paid" [toPay]="q.payment.to_pay_now" [total]="q.payment.total"></portal-progress-bar>
						<div class="co-pay-legend">
							<div class="co-pay-legend-row">
								<div class="co-pay-legend-left">
									<div class="qr-legend-dot" style="background:var(--c-success-solid);"></div>
									<span>Paid so far</span><span class="co-pay-pct">{{ payPct(q, 'paid') }}%</span>
								</div>
								<span class="co-pay-amt">{{ q.payment.paid | currency:q.currency_id }}</span>
							</div>
							<div class="co-pay-legend-row">
								<div class="co-pay-legend-left">
									<div class="qr-legend-dot" style="background:var(--c-primary-solid);"></div>
									<span>To pay now</span><span class="co-pay-pct">{{ payPct(q, 'to_pay_now') }}%</span>
								</div>
								<span class="co-pay-amt">{{ q.payment.to_pay_now | currency:q.currency_id }}</span>
							</div>
							<div class="co-pay-legend-row">
								<div class="co-pay-legend-left">
									<div class="qr-legend-dot qr-legend-dot-upcoming"></div>
									<span>Upcoming</span><span class="co-pay-pct">{{ payPct(q, 'upcoming') }}%</span>
								</div>
								<span class="co-pay-amt">{{ q.payment.upcoming | currency:q.currency_id }}</span>
							</div>
						</div>
					</ng-container>
				</div>

				<div class="qr-view">
					<portal-button (click)="openProposal(q)" [disabled]="!q.can_view_proposal" [title]="q.can_view_proposal ? null : 'No proposal published for this quote'">View Quote</portal-button>
				</div>

				<div class="qr-orig">
					<span class="qr-orig-val">{{ q.net_total | currency:q.currency_id }}</span>
					<span class="qr-orig-lbl">Total (excl. Tax)</span>
				</div>

				<div class="qr-actions" *ngIf="isPending(q)">
					<div class="portal-btn-group">
						<!-- Add a comment: opens the proposal with the comment modal auto-opened. -->
						<portal-button icon="wq wq-notes" [title]="preview.ready ? preview.blockedReason : (q.can_comment ? 'Add a comment' : 'No proposal published for this quote')" aria-label="Add a comment" (click)="commentQuote(q)" [disabled]="preview.ready || !q.can_comment"></portal-button>
						<portal-button *ngIf="canConfirm(q)" (click)="openToBeConfirmed(q)" [disabled]="preview.ready" [title]="preview.ready ? preview.blockedReason : null">To be confirmed</portal-button>
						<portal-button (click)="openReject(q)" [disabled]="preview.ready" [title]="preview.ready ? preview.blockedReason : null">Decline</portal-button>
						<portal-button (click)="acceptQuote(q)" [disabled]="preview.ready || !q.can_accept" [title]="preview.ready ? preview.blockedReason : (q.can_accept ? null : 'No proposal published for this quote')">Accept</portal-button>
					</div>
				</div>
			</div>
		</div>

		<!-- Footer -->
		<portal-project-footer [projectId]="projectId"></portal-project-footer>

	</ng-container>

	<portal-to-be-confirmed-modal #tbcModal (close)="onToBeConfirmed($event)"></portal-to-be-confirmed-modal>
	<portal-reject-modal #rejectModal (close)="onRejected($event)"></portal-reject-modal>
</div>
